module.exports = __webpack_public_path__ + "img/select-lang-btn-pt.1d6ed124.png";